import React, { useRef, useState, useEffect } from "react";
import emailjs from '@emailjs/browser';
import ReCAPTCHA from "react-google-recaptcha";

const recaptchaRef = React.createRef();

function onChange(value) {
  console.log("Captcha: ", value);
}

export const ContactUs = () => {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const [formData, setFormData] = useState({
    from_name: "",
    from_phone: "",
    from_email: "",
    from_message: ""
  });

  useEffect(() => {
    const { from_name, from_phone, from_email, from_message } = formData;
    setIsFormValid(
      from_name.trim() !== "" &&
      from_phone.trim() !== "" &&
      from_email.trim() !== "" &&
      from_message.trim() !== ""
    );
  }, [formData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setIsSuccess(false);

    emailjs
      .sendForm('contact_from_Quinns_Pian', 'template_sd5hp5q', form.current, {
        publicKey: "qBxH2cGP0FVJLErMU"
      })
      .then(() => {
        console.log('SUCCESS!');
        setIsSuccess(true);
        setIsSubmitting(false);
        setFormData({
          from_name: "",
          from_phone: "",
          from_email: "",
          from_message: ""
        });
      })
      .catch((error) => {
        console.log('FAILED...', error.text);
        setIsSubmitting(false);
      });
  };

  return (
    <section id="contactUs">
      <div className="shadow-lg contact-from w-75 mx-auto p-4">
        <div className="heading text-center">
          <h3>Request More Information</h3>
          <hr />
        </div>
        <div className="form-body mt-3">
          <form ref={form} onSubmit={sendEmail}>
            <div className="row">
              <div className="col-md-12 mb-3">
                <label>Name</label>
                <input
                  type="text"
                  name="from_name"
                  className="form-control mt-2"
                  placeholder="Enter Your Name"
                  value={formData.from_name}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-12 mb-3">
                <label>Phone Number</label>
                <input
                  type="text"
                  name="from_phone"
                  className="form-control mt-2"
                  placeholder="Enter Your Phone"
                  value={formData.from_phone}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-12 mb-3">
                <label>Email Address</label>
                <input
                  type="text"
                  name="from_email"
                  className="form-control mt-2"
                  placeholder="Enter Your Email"
                  value={formData.from_email}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-12 mb-3">
                <label>Message</label>
                <textarea
                  rows="6"
                  name="from_message"
                  className="form-control mt-2"
                  placeholder="Type Message..."
                  value={formData.from_message}
                  onChange={handleChange}
                />
              </div>

              <ReCAPTCHA
                sitekey="6LfbUrkrAAAAAPqcCtYmtVJJixJl2iLbnI82_Tab"
                ref={recaptchaRef}
                onChange={onChange}
              />

              <div className="col-md-12 mt-2">
                <button
                  type="submit"
                  className={`btn w-100 ${isSuccess ? 'btn-success' : 'btn-primary'}`}
                  disabled={!isFormValid || isSubmitting}
                >
                  {isSubmitting ? (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  ) : null}
                  {isSuccess ? "Sent Successfully!" : "Request More Information"}
                </button>
              </div>

              {isSuccess && (
                <div className="col-md-12 mt-3 text-center">
                  <span className="badge bg-success">Your message has been sent!</span>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
